
import Project13Img from '../assets/images/Proj_13.png';
import Project11Img from '../assets/images/Proj_11.png';
import Project8Img from '../assets/images/proj_8.png';
import Project5Img from '../assets/images/proj_5.png';
import Project4Img from '../assets/images/proj_4.png';
import Project7Img from '../assets/images/proj_7.png';
import Project2Img from '../assets/images/proj_2.png';
import Project3Img from '../assets/images/proj_3.png';
import Project14Img from '../assets/images/Proj_14.png';
import Project10Img from '../assets/images/Proj_10.png';
import Project9Img from '../assets/images/Proj_9.png';
import Project12Img from '../assets/images/Proj_12.png';
import Project1Img from '../assets/images/proj_1.png';
import Project6Img from '../assets/images/proj_6.png';
import Project15Img from '../assets/images/Proj_15.png';
import Project16Img from '../assets/images/Proj_16.png';
import Project17Img from '../assets/images/Proj_17.png';
import Project18Img from '../assets/images/Proj_18.png';


const projectsData = [
  {
    title: "Home Price Estimator",
    domain: "Real Estate",
    skills: ["Machine Learning", "Flask"],
    description: 
    <ul>
      <li>Full-stack machine learning web app that predicts real-estate prices across Hyderabad.</li>
      <li>Backend built with Python, Flask, and scikit-learn for model inference and locality/property-type APIs.</li>
      <li>React frontend with a clean Figma-inspired UI, instant dropdown caching, confidence ranges, feature contributions, and mini-charts.</li>
      <li>Deployed using Render (backend) and Vercel (frontend) for fast and scalable performance.</li>
      <li>Demonstrates practical skills in ML model deployment, REST API integration, and building production-ready real-estate analytics tools.</li>
    </ul>,
    links: {
      live_link: "https://hyderabad-home-price-prediction.vercel.app/",
      linkedin: "https://www.linkedin.com/posts/rohithreddyrudraiahgari_machinelearning-datascience-flask-activity-7401499077336858624-Lwl0?utm_source=share&utm_medium=member_desktop&rcm=ACoAADd2oJMBHDEQJD_uc_xW4E0ts3YRCMEOulk",
      github: "https://github.com/rohithreddy2001/Hyderabad-Home-Price-Prediction.git"
    },
    image: Project18Img
  },
  {
    title: "Cold Mail Generator",
    domain: "SaaS",
    skills: ["LangChain", "Python", "Streamlit"],
    description: 
    <ul>
      <li>Generative AI–based web app that automates outreach for job applications.</li>
      <li>Built with Python, Streamlit, and LangChain to scrape job postings and extract key details like role, skills, and experience.</li>
      <li>Generates personalized cold emails using LLMs and integrates project portfolio links for stronger relevance and engagement.</li>
      <li>Hosted on Streamlit Cloud, removing manual effort and speeding up job-application workflows.</li>
      <li>Demonstrates real-world application of AI in automating professional communication.</li>
    </ul>,
    links: {
      live_link: "https://cold-mail-generator-genai.streamlit.app/",
      // linkedin: "https://www.linkedin.com/posts/rohithreddyrudraiahgari_webdevelopment-fullstack-react-activity-7326196978978095105-ouxB?utm_source=share&utm_medium=member_desktop&rcm=ACoAADd2oJMBHDEQJD_uc_xW4E0ts3YRCMEOulk",
      github: "https://github.com/rohithreddy2001/Cold-Mail-Generator-GenAi.git"
    },
    image: Project17Img
  },
  {
    title: "Grocery Store Management System",
    domain: "Retail",
    skills: ["React", "Flask", "MySQL"],
    description:
    <ul>
      <li>Built a Grocery Store Management System for efficient product and order handling.</li>
      <li>Integrated automatic UOM selection to reduce entry errors, auto-assigning units like “Kg” for items such as daal across 100+ products.</li>
      <li>Enabled creation of 50+ orders with dynamic total calculations averaging $150 per order.</li>
      <li>Optimized navigation across Dashboard, Product Management, and Order pages, reducing page transition time by 40%.</li>
      <li>Deployed using Vercel and Render, maintaining 99.9% uptime.</li>
      <li>Improved accuracy and efficiency, saving store managers 10+ hours weekly.</li>
    </ul>,
    links: {
      live_link: "https://grocery-store-management-system-livid.vercel.app/",
      linkedin: "https://www.linkedin.com/posts/rohithreddyrudraiahgari_webdevelopment-fullstack-react-activity-7326196978978095105-ouxB?utm_source=share&utm_medium=member_desktop&rcm=ACoAADd2oJMBHDEQJD_uc_xW4E0ts3YRCMEOulk",
      github: "https://github.com/rohithreddy2001/Grocery_Store_Management_System.git"
    },
    image: Project15Img
  },
  {
    title: "Online Retail Performance Analysis",
    domain: "E-commerce",
    skills: ["Excel", "Power BI", "DAX"],
    description:
    <ul>
      <li>Analyzed retail sales data revealing $10.67M revenue from 6M units, with $9.85M generated on weekdays.</li>
      <li>Identified seasonal performance shifts: 30.69% revenue increase in November and 57.68% drop in December.</li>
      <li>Highlighted top customers and regions, including Customer 14646 contributing $280K and highest revenue from the Netherlands ($285K) and Ireland ($283K).</li>
      <li>Delivered insights to strengthen strategy, refine marketing decisions, and improve sales performance.</li>
    </ul>,
    links: {
      live_link: "https://app.powerbi.com/view?r=eyJrIjoiMWJkOGJhYWYtOGRjMS00NTYwLWE0ZTAtZDlkNWE3ODJiMjk2IiwidCI6ImRmODY3OWNkLWE4MGUtNDVkOC05OWFjLWM4M2VkN2ZmOTVhMCJ9",
      power_bi: "https://app.powerbi.com/view?r=eyJrIjoiMWJkOGJhYWYtOGRjMS00NTYwLWE0ZTAtZDlkNWE3ODJiMjk2IiwidCI6ImRmODY3OWNkLWE4MGUtNDVkOC05OWFjLWM4M2VkN2ZmOTVhMCJ9",
      linkedin: "https://www.linkedin.com/posts/rohithreddyrudraiahgari_online-retail-performance-analysis-activity-7292792740805783553-90jS?utm_source=share&utm_medium=member_desktop&rcm=ACoAADd2oJMBHDEQJD_uc_xW4E0ts3YRCMEOulk",
      github: "https://github.com/rohithreddy2001/TATA_Online_Retail_Performance_Analysis.git"
    },
    image: Project13Img
  },
  {
    title: "Stock Portfolio Analysis and Forecasting",
    domain: "FinTech",
    skills: ["Machine Learning", "Pandas"],
    description:
    <ul>
      <li>Analyzed stock market data using Python and Pandas, forecasting portfolio values with machine learning.</li>
      <li>Processed JSON data and automated extraction to Excel for 350+ stocks.</li>
      <li>Applied statistical models including OLS, polynomial regression, and exponential smoothing, achieving 59.76% prediction accuracy.</li>
      <li>Visualized price trends with Plotly, using RSI and moving averages for deeper insights.</li>
      <li>Provided actionable insights to improve stock selection and strengthen portfolio performance.</li>
    </ul>,
    links: {
      live_link: "https://github.com/rohithreddy2001/Stock-Portfolio-Forecasting-with-Statistical-Modeling/blob/main/Stock%20Portfolio%20NoteBook.ipynb",
      github: "https://github.com/rohithreddy2001/Stock-Portfolio-Forecasting-with-Statistical-Modeling"
    },
    image: Project16Img
  },
  {
    title: "GoodCabs Transportation Analysis",
    domain: "Transportation & Mobility",
    skills: ["MySQL", "Power BI", "DAX"],
    description:
    <ul>
      <li>Analyzed city-level transportation performance, covering trip volume, pricing efficiency, and passenger satisfaction.</li>
      <li>Identified seasonal demand patterns and key differences between weekday and weekend activity.</li>
      <li>Explored repeat passenger behavior to evaluate loyalty trends and retention opportunities.</li>
      <li>Delivered insights that support improving monthly trip targets and boosting passenger ratings.</li>
    </ul>,
    links: {
      live_link: "https://app.powerbi.com/view?r=eyJrIjoiYTllYzFmNGUtYTlhMS00MjVlLWFmNjUtZjJiMjdlZjMyMWMxIiwidCI6ImRmODY3OWNkLWE4MGUtNDVkOC05OWFjLWM4M2VkN2ZmOTVhMCJ9",
      power_bi: "https://app.powerbi.com/view?r=eyJrIjoiYTllYzFmNGUtYTlhMS00MjVlLWFmNjUtZjJiMjdlZjMyMWMxIiwidCI6ImRmODY3OWNkLWE4MGUtNDVkOC05OWFjLWM4M3VkN2ZmOTVhMCJ9",
      linkedin: "https://www.linkedin.com/posts/rohithreddyrudraiahgari_goodcabs-transportation-operations-activity-7272093927703240704-4eED?utm_source=share&utm_medium=member_desktop",
      github: "https://github.com/rohithreddy2001/Transportation-Operations-Insights",
      youtube: "https://youtu.be/KXUZH-BEFIc?si=zG6Zm4H5igmStEw3"
    },
    image: Project11Img
  },
  {
    title: "Supply Chain Analysis",
    domain: "FMCG",
    skills: ["Power BI", "DAX", "MySQL"],
    description:
    <ul>
      <li>Analyzed key supply chain metrics including On-Time Delivery %, OTIF %, and Line Fill Rate for AtliQ Mart.</li>
      <li>Built an interactive Power BI dashboard with advanced bookmarks, slicers, and optimized DAX formulas.</li>
      <li>Increased dashboard navigation efficiency by 25% and improved report accuracy by 15%.</li>
    </ul>,
    links: {
      live_link: "https://app.powerbi.com/view?r=eyJrIjoiNGZhZTBlZWItYjE1YS00YzIyLThjNGUtYTFkZjQ1MGI4OWY2IiwidCI6ImRmODY3OWNkLWE4MGUtNDVkOC05OWFjLWM4M2VkN2ZmOTVhMCJ9",
      power_bi: "https://app.powerbi.com/view?r=eyJrIjoiNGZhZTBlZWItYjE1YS00YzIyLThjNGUtYTFkZjQ1MGI4OWY2IiwidCI6ImRmODY3OWNkLWE4MGUtNDVkOC05OWFjLWM4M3VkN2ZmOTVhMCJ9",
      linkedin: "https://www.linkedin.com/posts/rohithreddyrudraiahgari_codebasicsresumechallenge-supplychain-fmcg-activity-7241290959064367104-vMmm?utm_source=share&utm_medium=member_desktop",
      github: "https://github.com/rohithreddy2001/Supply-Chain-Issue-Analysis"
    },
    image: Project8Img
  },
  {
    title: "Electric Vehicles Analysis",
    domain: "Automotive",
    skills: ["MySQL", "Power BI", "DAX"],
    description:
    <ul>
      <li>Analyzed market data for an automotive company planning to launch EVs in India.</li>
      <li>Identified key insights related to consumer demand, pricing trends, and regional adoption potential.</li>
      <li>Delivered a data-backed foundation for strategic launch and scaling decisions in a fast-growing EV market.</li>
    </ul>,
    links: {
      live_link: "https://app.powerbi.com/view?r=eyJrIjoiNmJjNDQzYTYtZGQ0NC00YzFhLWI2ZjAtNDZhNzNiOGY3MmRlIiwidCI6ImRmODY3OWNkLWE4MGUtNDVkOC05OWFjLWM4M2VkN2ZmOTVhMCJ9",
      power_bi: "https://app.powerbi.com/view?r=eyJrIjoiNmJjNDQzYTYtZGQ0NC00YzFhLWI2ZjAtNDZhNzNiOGY3MmRlIiwidCI6ImRmODY3OWNkLWE4MGUtNDVkOC05OWFjLWM4M3VkN2ZmOTVhMCJ9",
      linkedin: "https://www.linkedin.com/posts/rohithreddyrudraiahgari_electric-vehicles-insights-activity-7228758833618116611-Wlqd?utm_source=share&utm_medium=member_desktop",
      github: "https://github.com/rohithreddy2001/Electric-Vehicle-Analysis.git",
      youtube: "https://youtu.be/lYpQ74G9p0M?si=tqZDZ1-9sioDyLzx"
    },
    image: Project5Img
  },
  {
    title: "Insights On IPL 2024 For A Sports Magazine",
    domain: "Sports",
    skills: ["MySQL", "Power BI", "DAX"],
    description:
    <ul>
      <li>Analyzed key cricket statistics including total runs, batting averages, bowler economy rates, and dot-ball percentages.</li>
      <li>Evaluated team performance trends across multiple years to understand competitive patterns and consistency.</li>
      <li>Provided actionable insights valuable for analysts, teams, and cricket enthusiasts.</li>
    </ul>,
    links: {
      live_link: "https://app.powerbi.com/view?r=eyJrIjoiMmZjMDVmNDgtN2ZmMS00MTk2LTgyZWMtNWE1ZDI0OGVlOTY2IiwidCI6ImRmODY3OWNkLWE4MGUtNDVkOC05OWFjLWM4M2VkN2ZmOTVhMCJ9&pageName=ReportSection8f5075557b9747d605d6",
      power_bi: "https://app.powerbi.com/view?r=eyJrIjoiMmZjMDVmNDgtN2ZmMS00MTk2LTgyZWMtNWE1ZDI0OGVlOTY2IiwidCI6ImRmODY3OWNkLWE4MGUtNDVkOC05OWFjLWM4M3VkN2ZmOTVhMCJ9&pageName=ReportSection8f5075557b9747d605d6",
      linkedin: "https://www.linkedin.com/posts/rohithreddyrudraiahgari_ipl-insights-for-2024-season-activity-7184071052161921024-WiB-?utm_source=share&utm_medium=member_desktop",
      github: "https://github.com/rohithreddy2001/IPL-2024-Analysis.git",
      youtube: "https://youtu.be/b2T0TpZnl-Y?si=5PhGnEN-CEjYBjJ1"
    },
    image: Project4Img
  },
  {
    title: "Telangana Tourism Analysis",
    domain: "Tourism",
    skills: ["Excel", "Power BI", "DAX"],
    description:
    <ul>
      <li>Built a Telangana Tourism analytics dashboard highlighting tourism trends across the state with a focus on Hyderabad.</li>
      <li>Ranked districts by growth rate to identify high-performing and emerging tourism locations.</li>
      <li>Included forecasting features for predicting tourist volume and revenue potential.</li>
    </ul>,
    links: {
      live_link: "https://app.powerbi.com/view?r=eyJrIjoiZWUzNmI2MjMtNTM1My00MmJkLThmMzgtNTYzMDM1ZWFhYTdiIiwidCI6ImRmODY3OWNkLWE4MGUtNDVkOC05OWFjLWM4M2VkN2ZmOTVhMCJ9&pageName=05aeff519c9307c8bc26",
      power_bi: "https://app.powerbi.com/view?r=eyJrIjoiZWUzNmI2MjMtNTM1My00MmJkLThmMzgtNTYzMDM1ZWFhYTdiIiwidCI6ImRmODY3OWNkLWE4MGUtNDVkOC05OWFjLWM4M3VkN2ZmOTVhMCJ9&pageName=05aeff519c9307c8bc26",
      linkedin: "https://www.linkedin.com/posts/rohithreddyrudraiahgari_tstourism-activity-7203658256177594368-7wTQ?utm_source=share&utm_medium=member_desktop",
      github: "https://github.com/rohithreddy2001/TS_Tourism.git"
    },
    image: Project7Img
  },
  {
    title: "Cricket Data Analysis",
    domain: "Sports",
    skills: ["Pandas", "Power BI", "DAX"],
    description:
    <ul>
      <li>Analyzed T20 World Cup 2022 data to identify top Batters, Bowlers, and All-Rounders.</li>
      <li>Evaluated multiple performance metrics to ensure fair and data-driven player ranking.</li>
      <li>Delivered clear insights into standout performers across different skill categories.</li>
    </ul>,
    links: {
      live_link: "https://app.powerbi.com/view?r=eyJrIjoiMTNmMDE3M2YtMzM2OC00ZjkwLWIwNjMtNThhMmIwNWE5MjdiIiwidCI6ImRmODY3OWNkLWE4MGUtNDVkOC05OWFjLWM4M2VkN2ZmOTVhMCJ9&pageName=ReportSection",
      power_bi: "https://app.powerbi.com/view?r=eyJrIjoiMTNmMDE3M2YtMzM2OC00ZjkwLWIwNjMtNThhMmIwNWE5MjdiIiwidCI6ImRmODY3OWNkLWE4MGUtNDVkOC05OWFjLWM4M3VkN2ZmOTVhMCJ9&pageName=ReportSection",
      linkedin: "https://www.linkedin.com/posts/rohithreddyrudraiahgari_cricket-data-analysis-activity-7176843428771627008-oKda?utm_source=share&utm_medium=member_desktop",
      github: "https://github.com/rohithreddy2001/2022-T20-WC-Analysis.git"
    },
    image: Project2Img
  },
  {
    title: "Credit Card Financial Report",
    domain: "Banking",
    skills: ["MySQL", "Power BI", "DAX"],
    description:
    <ul>
      <li>Designed a comprehensive weekly dashboard for monitoring credit card performance.</li>
      <li>Provided real-time visibility into key metrics and trends across credit card operations.</li>
      <li>Enabled stakeholders to track performance, identify issues early, and make data-driven decisions.</li>
    </ul>,
    links: {
      live_link: "https://app.powerbi.com/view?r=eyJrIjoiZDJhYzJmZTctNmQ2MS00NThjLTg1NDMtMzQ5YWZhYjQ3NjlkIiwidCI6ImRmODY3OWNkLWE4MGUtNDVkOC05OWFjLWM4M2VkN2ZmOTVhMCJ9&pageName=ReportSection36d300139988ed03a040",
      power_bi: "https://app.powerbi.com/view?r=eyJrIjoiZDJhYzJmZTctNmQ2MS00NThjLTg1NDMtMzQ5YWZhYjQ3NjlkIiwidCI6ImRmODY3OWNkLWE4MGUtNDVkOC05OWFjLWM4M3VkN2ZmOTVhMCJ9&pageName=ReportSection36d300139988ed03a040",
      linkedin: "https://www.linkedin.com/posts/rohithreddyrudraiahgari_credit-card-financial-report-activity-7190610595958693888-DYLN?utm_source=share&utm_medium=member_desktop",
      github: "https://github.com/rohithreddy2001/Credit-Card-Financial-Analysis.git"
    },
    image: Project3Img
  },
  {
    title: "HR Data Analysis",
    domain: "Human Resources",
    skills: ["Pandas", "Matplotlib", "MySQL"],
    description:
    <ul>
      <li>Analyzed employee attrition using Python and MySQL on a Kaggle HR dataset.</li>
      <li>Identified high attrition among non-trained employees (53.82%) and Executive Office roles (66.67%).</li>
      <li>Explored department-wise trends, hiring patterns, and work-life balance factors affecting retention.</li>
      <li>Delivered insights supporting data-driven HR strategies to reduce attrition and improve workforce stability.</li>
    </ul>,
    links: {
      live_link: "https://github.com/rohithreddy2001/HR-Data-Analytics/blob/main/HR_Data_Analytics.ipynb",
      github: "https://github.com/rohithreddy2001/HR-Data-Analytics",
      linkedin: "https://www.linkedin.com/posts/rohithreddyrudraiahgari_hr-data-analysis-activity-7298585619201413121-BvIX?utm_source=share&utm_medium=member_desktop&rcm=ACoAADd2oJMBHDEQJD_uc_xW4E0ts3YRCMEOulk"
    },
    image: Project14Img
  },
  {
    title: "Call Centre Report - 2023",
    domain: "Customer Service",
    skills: ["DAX", "Excel", "Pivot Tables"],
    description:
    <ul>
      <li>Analyzed a 2023 Call Center dataset generating $96,623 from 1,000 calls over 1,498 minutes, with an average rating of 3.89.</li>
      <li>Identified 307 five-star ratings and highlighted Rep R03 as the top performer with $20.9K revenue.</li>
      <li>Found peak call activity in April and October, with Wednesdays as the busiest day.</li>
      <li>Revealed Cleveland as the location with the highest number of male callers.</li>
      <li>Showed strong rating distribution dominated by 4- and 5-star feedback, critical for improving performance and satisfaction.</li>
    </ul>,
    links: {
      live_link: "https://view.officeapps.live.com/op/view.aspx?src=https%3A%2F%2Fraw.githubusercontent.com%2Frohithreddy2001%2FCall-Centre-Report-2023%2Frefs%2Fheads%2Fmain%2Fcall-centre-excel-portfolio-project.xlsx&wdOrigin=BROWSELINK",
      excel: "https://view.officeapps.live.com/op/view.aspx?src=https%3A%2F%2Fraw.githubusercontent.com%2Frohithreddy2001%2FCall-Centre-Report-2023%2Frefs%2Fheads%2Fmain%2Fcall-centre-excel-portfolio-project.xlsx&wdOrigin=BROWSELINK",
      linkedin: "https://www.linkedin.com/posts/rohithreddyrudraiahgari_dataanalysis-excelreporting-analytics-activity-7250373114725875712-KSam?utm_source=share&utm_medium=member_desktop",
      github: "https://github.com/rohithreddy2001/Call-Centre-Report-2023"
    },
    image: Project10Img
  },
  {
    title: "WPL 2024 Excel Dashboard",
    domain: "Sports",
    skills: ["Excel", "Pivot Tables"],
    description:
    <ul>
      <li>Built an Excel dashboard for the Women’s Premier League (WPL) 2024 highlighting top batting and bowling performances.</li>
      <li>Added interactive filters to view and compare stats for specific teams and players.</li>
      <li>Enabled quick analysis and performance comparison across the entire league.</li>
    </ul>,
    links: {
      live_link: "https://1drv.ms/x/s!AngFnxJUeDIVmieDhMoftqETjcbQ",
      excel: "https://1drv.ms/x/s!AngFnxJUeDIVmieDhMoftqETjcbQ",
      github: "https://github.com/rohithreddy2001/WPL-2024-DASHBOARD"
    },
    image: Project9Img
  },
  {
    title: "Consumer Goods Ad-Hoc Insights",
    domain: "Consumer Goods",
    skills: ["MySQL", "Excel", "Power Point"],
    description:
    <ul>
      <li>Produced ad-hoc insights for a consumer goods company operating across APAC regions.</li>
      <li>Reported 36.33% growth in unique products from 2020 to 2021 through detailed product analysis.</li>
      <li>Identified Notebooks and Accessories as top-performing categories, with Desktops showing the highest growth at 214.29%.</li>
      <li>Revealed Retailers as the dominant channel contributing 73.22% of sales, with Flipkart offering the highest discounts.</li>
    </ul>,
    links: {
      live_link: "https://1drv.ms/p/c/15327854129f0578/EdPZpwUuazdOnM-4qordI5MBr_K52mHvXR0XJWXDT3nWgg",
      powerpoint: "https://1drv.ms/p/c/15327854129f0578/EdPZpwUuazdOnM-4qordI5MBr_K52mHvXR0XJWXDT3nWgg",
      linkedin: "https://www.linkedin.com/posts/rohithreddyrudraiahgari_consumer-goods-ad-hoc-insights-activity-7288455998091018240-vjO0?utm_source=share&utm_medium=member_desktop",
      github: "https://github.com/rohithreddy2001/Consumer_Goods_Insights"
    },
    image: Project12Img
  },
  {
    title: "Hospitality Revenue Analytics",
    domain: "Hospitality",
    skills: ["Excel", "Power BI", "DAX"],
    description: "I analyzed historical data to offer revenue insights to the AtliQ Grand hotel team, with the goal of improving revenue and market share relative to other hotels.",
    links: {
      live_link: "https://app.powerbi.com/view?r=eyJrIjoiYzRlNjZlMTQtNzc3NS00Yzc2LTg3MzItOWM4ODViNmIwMTE0IiwidCI6ImRmODY3OWNkLWE4MGUtNDVkOC05OWFjLWM4M2VkN2ZmOTVhMCJ9&pageName=ReportSection",
      power_bi: "https://app.powerbi.com/view?r=eyJrIjoiYzRlNjZlMTQtNzc3NS00Yzc2LTg3MzItOWM4ODViNmIwMTE0IiwidCI6ImRmODY3OWNkLWE4MGUtNDVkOC05OWFjLWM4M3VkN2ZmOTVhMCJ9&pageName=ReportSection",
      linkedin: "https://www.linkedin.com/posts/rohithreddyrudraiahgari_hospitality-dashboard-activity-7180462633098121216-E6GX?utm_source=share&utm_medium=member_desktop",
      github: "https://github.com/rohithreddy2001/Hospitality-Analysis.git"
    },
    image: Project1Img
  },
  {
    title: "COVID 19 Data Analysis",
    domain: "Health Care",
    skills: ["Pandas", "Matplotlib", "NumPy"],
    description: "This project aims to provide people with insights into the COVID-19 situation in their country, allowing them to identify areas where the virus is spreading rapidly and enabling informed planning.",
    links: {
      live_link: "https://github.com/rohithreddy2001/miniProject2.io/blob/main/MINI_PROJECT-2_B3/Mini_Project_B3.ipynb",
      github: "https://github.com/rohithreddy2001/miniProject2.io.git"
    },
    image: Project6Img
  }
];


export default projectsData;



  